<template>
  <div id="login">
    <HeaderSub/>
	<div class="login-dbw-wrap" :style="{'background': 'url('+activeInfo.secondLoginUrl+') no-repeat center center', 'height': '752px'}" v-if="activityType==2">
		<!-- <img class="login-banner-dbw" src="@/assets/login-banner-dbw.png"/> -->
		<div style="width: 960px; margin:0 auto">
			<div class="login-wrap">
					<h2>麒麟软件账号登录</h2>
					<span class="login-version">(校园版)</span>
					<ul class="login-ul">
						<li>
							<input type="text" v-model="username" placeholder="邮件地址/账号"/>
						</li>
						<li>
							<input type="password" v-model="password" placeholder="密码"/>
						</li>
						<li class="login-code">
							<input type="text" v-model="code" placeholder="图形验证码"/>
							<img class="image-code" :src="imageCodeSrc" @click="getImageCode"/>
						</li>
					</ul>
					<span class="login-btn" @click="toLoginBtn">登 录</span>
					<div class="login-tips clearfix">
						<a :href="registerUrl" target="_blank">注册</a>
						<span class="login-line"></span>
						<a :href="passwordUrl"  target="_blank">忘记密码</a>
					</div>
				</div>
			</div>
		</div>
    <div class="login-wrap" v-else-if="activityType==1">
		<h2>麒麟软件账号登录</h2>
		<ul class="login-ul">
			<li>
				<input type="text" v-model="username" placeholder="邮件地址/账号"/>
			</li>
			<li>
				<input type="password" v-model="password" placeholder="密码"/>
			</li>
			<li class="login-code">
				<input type="text" v-model="code" placeholder="图形验证码"/>
				<img class="image-code" :src="imageCodeSrc" @click="getImageCode"/>
			</li>
		</ul>
		<span class="login-btn" @click="toLoginBtn">登 录</span>
		<div class="login-tips clearfix">
			<a :href="registerUrl" target="_blank">注册</a>
			<span class="login-line"></span>
			<a :href="passwordUrl"  target="_blank">忘记密码</a>
		</div>
	</div>
  </div>
</template>

<script>
import qs from 'qs'
import HeaderSub from '../../components/HeaderSub'
import { post, ajaxParam } from '../../units/request.js'
// import { tool } from '../../units/tools.js'
export default {
  name: '',
  data(){
	return {
		username: '',   //登录用户名
		password: '', //密码
		code: '', //图形验证码
		imageCodeSrc: '', //图形验证码图片地址
		registerUrl: 'https://id.kylinos.cn/registered?userSource=forum&redirectUrl=https://gongece.kylinos.cn',
		returnUrl: '',
		passwordUrl: 'https://id.kylinos.cn/find?userSource=forum&redirectUrl=https://gongece.kylinos.cn',
		activityType: 1,
		activeInfo: {}
	}
  },
  components: {
    HeaderSub
  },
  methods: {
	toLoginBtn(){
		let username = this.username
		let password = this.password
		let code = this.code
		if(!username) {
			this.$message.error('用户名不能为空')
			return
		}
		if(!password) {
			this.$message.error('请输入您的密码')
			return
		}
		if(!code) {
			this.$message.error('请输入图形验证码')
			return
		}
		this.toLogin()
	},
	async toLogin(){
		let url = 'v1/user/idLogin'
		let param = {
		imgId: this.imgId,
		userName: this.username,
		pwd: this.password,
		code: this.code
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			//存储登录信息
			localStorage.setItem('user',res.data.entity)
			localStorage.setItem('userId', res.data.entity.id)
      localStorage.setItem('uuid', res.data.entity.uuid)
      localStorage.setItem('token', res.data.entity.token)
			localStorage.setItem('isLoginStudent', 1)
			this.$router.push({
				path: '/userinfo'
			})
		} else {
			this.$message.error(res.data.msg)
		}
	},
	async getImageCode() {
		let param = {}
		const res = await post('v1/user/getMCodeImage', param)
		this.imageCodeSrc = res.data.entity.img
		this.imgId = res.data.entity.imgId
	},
	async getRedirectUrl() {
		let param = {
			code: 'QILIN-ID-REDIRECT-LOGIN'
		}
		const res = await post('/v1/sysConfig/getConfigByCode', qs.stringify(param))
		if(res.data.code==200) {
			this.returnUrl = res.data.entity.configValue
			this.registerUrl = this.registerUrl+ this.returnUrl
			this.passwordUrl = this.passwordUrl+ this.returnUrl
		}
	},
	//获取当前活动信息
	async getActiveInfo(){
		let url = 'v1/activity/getIndexActivity'
		let param = {}
		const res = await post(url, param)
		if(res.data.code==200) {
			let entity = res.data.entity
			this.activeInfo = entity
			this.activityType = entity.activityType
			localStorage.setItem('activityId', entity.id)
			localStorage.setItem('activityType', entity.activityType)
			localStorage.setItem('activeInfo', JSON.stringify(entity))
		} else {
			this.$message.error(res.data.msg)
		}
	}
  },
  created(){
	this.getImageCode()
	this.getActiveInfo()
	//this.getRedirectUrl()
	window.scrollTo(0, 0)
  }
}
</script>

<style scoped>
.login-tips{width:130px; margin: 0 auto; text-align: center;}
.login-tips a{float:left; height:20px; color:#007DFF; line-height: 18px}
.login-line{float:left; width:1px; height:18px; margin:0 20px; background:#e5e5e5}
.login-ul li.login-code{position: relative}
.login-ul li.login-code input{width:50%}
.image-code{float:right}
.login-dbw-wrap{ margin:0 auto; display: flex; justify-content: flex-end;}
.login-dbw-wrap .login-wrap{
	width: 224px;
	height: 320px;
	padding: 10px 22px 0;
	background:#fff;
	box-shadow: 0px 1px 7px 2px rgba(178,178,178,0.1600);
}
.login-dbw-wrap .login-wrap{
	margin-right:0;
	margin-bottom: 80px;
	margin-top: 160px;
}
.login-dbw-wrap .login-wrap h2{padding-bottom: 10px; font-size: 16px;}
.login-dbw-wrap .login-ul li{height: 24px; border-radius: 3px;}
.login-dbw-wrap .login-btn{margin-top: 30px; height:24px; line-height: 24px; font-size: 9px; border-radius: 3px;background: #4B81EF;}
.login-dbw-wrap .login-tips{width: 114px}
.login-dbw-wrap .login-tips a{font-size: 9px;}
.login-version{display: flex; justify-content: center; margin-top: -15px; font-size: 9px;}
.login-dbw-wrap .image-code{width: 65px}
</style>
